// @flow
import { sortBy } from 'lodash';

import {
  FETCH_FAQ_CATEGORIES,
  FETCH_FAQ_CATEGORIES_SUCCESS,
  FETCH_FAQ_CATEGORY_QUESTIONS_SUCCESS
} from '@screens/FAQs/redux/constants';

import type { Action } from '@screens/FAQs/types';
import type { State } from '../types';

const initialState: State = {
  requesting: false,
  categories: [],
  questions: []
};

const reducer = (state: State = initialState, action: Action) => {
  switch (action.type) {
    case FETCH_FAQ_CATEGORIES:
      return {
        ...state,
        requesting: true
      };

    case FETCH_FAQ_CATEGORIES_SUCCESS:
      return {
        ...state,
        requesting: false,
        categories: action.data
      };

    case FETCH_FAQ_CATEGORY_QUESTIONS_SUCCESS:
      return {
        ...state,
        questions: sortBy(action.data, ['attributes.position'])
      };

    default:
      return state;
  }
};

export default reducer;
